import { render, staticRenderFns } from "./ScreenSaver.vue?vue&type=template&id=00f686a2&scoped=true&"
import script from "./ScreenSaver.vue?vue&type=script&lang=ts&"
export * from "./ScreenSaver.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenSaver.vue?vue&type=style&index=0&id=00f686a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f686a2",
  null
  
)

export default component.exports